import { User } from "@/api";
import { entity, persistence } from "simpler-state";

declare global {
  interface Window {
    $crisp?: any;
  }
  let $crisp: any;
}

export const UserState = entity<User | null>(null, [persistence("user")])

export function setUser(user: User) {
  UserState.set(user)
  if (window.$crisp) {
    $crisp.push(["do", "session:reset"])
    $crisp.push(["set", "user:email", user.email]);
  }
}

export function clearUser() {
  UserState.set(null)
}

/**
 * Internal (MarginWiz-side) users, as opposed to brand users. Used to gate
 * operational details — sync errors, job internals — that would only alarm a brand.
 */
export function is_internal_user(user: User | null | undefined): boolean {
  return user?.role === "system_admin" || user?.role === "consultant"
}

/**
 * MarginWiz staff only — deliberately narrower than {@link is_internal_user}, which also admits
 * consultants. Use this to gate features that are not ready for anyone outside the team to find,
 * where a consultant sitting with a brand is the wrong audience too.
 */
export function is_system_admin(user: User | null | undefined): boolean {
  return user?.role === "system_admin"
}
